export const LOGISTICS_MANIFEST_LS = 'logisticsManifest'
export const PACKAGES = [
  ['@logistics-auto1-orders-widget', 'ordersWidgetUrl', 'latest'],
  [
    '@logistics-auto1-orders-widget-on-my-orders',
    'ordersWidgetOnMyOrdersUrl',
    'latest'
  ]
]
